module.exports = __webpack_public_path__ + "static/media/unchecked.fd224ff8.svg";